import { useId, type ButtonHTMLAttributes, type HTMLAttributes, type ReactNode } from 'react';

import { cn } from '../../../lib/utils.js';
import { ShellIconLayers } from '../app-shell/shell-stroke-icon.js';

import { QuickPanelDockBadge } from './quick-panel.js';

export interface QuickPanelDockFabProps extends HTMLAttributes<HTMLDivElement> {
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
  hidden?: boolean;
  aggregateBadge?: number;
  children: ReactNode;
}

export function QuickPanelDockFab({
  expanded,
  onExpandedChange,
  hidden = false,
  aggregateBadge,
  className,
  children,
  ...props
}: QuickPanelDockFabProps) {
  const pillId = useId();

  if (hidden) {
    return null;
  }

  return (
    <div className={cn('qp-dock-fab', expanded && 'is-expanded', className)} {...props}>
      {expanded ? (
        <div id={pillId} className="qp-dock-fab-pill">
          {children}
        </div>
      ) : null}
      <QuickPanelDockFabTrigger
        expanded={expanded}
        {...(aggregateBadge != null ? { aggregateBadge } : {})}
        aria-controls={pillId}
        onClick={() => {
          onExpandedChange(!expanded);
        }}
      />
    </div>
  );
}

export interface QuickPanelDockFabTriggerProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  expanded: boolean;
  aggregateBadge?: number;
}

export function QuickPanelDockFabTrigger({
  expanded,
  aggregateBadge,
  className,
  type = 'button',
  ...props
}: QuickPanelDockFabTriggerProps) {
  return (
    <button
      type={type}
      className={cn('qp-dock-fab-trigger', expanded && 'is-expanded', className)}
      aria-expanded={expanded}
      aria-haspopup="true"
      aria-label="Painéis rápidos"
      {...props}
    >
      <ShellIconLayers size={18} strokeWidth={2} />
      {aggregateBadge != null && aggregateBadge > 0 ? (
        <QuickPanelDockBadge>{aggregateBadge > 99 ? '99+' : aggregateBadge}</QuickPanelDockBadge>
      ) : null}
    </button>
  );
}
